<template>
<div>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    width="780px"
    :close-on-click-modal="false"
    :visible.sync="visible" append-to-body>

    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
        <el-tabs>
            <el-tab-pane class="tab_style" :key="1" label="通告信息" style="min-height: 42vh;">
            <el-row>
            <el-col :span="12">
                <el-form-item label="类型" prop="noticeType">
                <el-select v-model="dataForm.noticeType" placeholder="类型" size="small">
                    <el-option value="0" label="通知公告"/>
                    <el-option value="1" label="供应商绩效通知"/>
                </el-select>
                <!-- <el-input placeholder="类型" size="small" v-model="dataForm.noticeType"/> -->
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="状态" prop="noticeStatus">
                <el-select v-model="dataForm.noticeStatus" placeholder="状态" size="small">
                    <el-option value="0" label="正常"/>
                    <el-option value="1" label="关闭"/>
                </el-select>
                </el-form-item>
            </el-col>
            </el-row>
            <el-row>
            <el-col :span="12">
                <el-form-item label="通知类型" prop="sendType">
                <el-radio-group v-model="dataForm.sendType" size="small">
                    <!-- <el-radio-button label="0">潜在</el-radio-button>
                    <el-radio-button label="1">合格</el-radio-button>
                    <el-radio-button label="2">一次性</el-radio-button> -->
                    <el-radio-button label="8">全部</el-radio-button>
                    <el-radio-button label="9">部分</el-radio-button>
                </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :span="12" v-if="dataForm.sendType == '9'">
                <el-button plain size="small" @click="selectSupplier()" icon="el-icon-plus">选择部分供应商</el-button> 已选{{sendListSize}}个
                <el-input style="visibility:hidden" size="small" v-model="dataForm.sendList"/>
            </el-col>
            </el-row>
            <el-row>
            <el-col :span="24">
                <el-form-item label="标题" prop="noticeTitle">
                <el-input v-model="dataForm.noticeTitle" placeholder="标题"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="内容" prop="noticeContent">
                <el-input type="textarea" v-model="dataForm.noticeContent" :rows="10" placeholder="内容"></el-input>
                </el-form-item>
            </el-col>
            </el-row>
            </el-tab-pane>
            <el-tab-pane class="tab_style" :key="2" label="附件文件">
                <FileUpDown ref="FileUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown>
            </el-tab-pane>
        </el-tabs>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">
        确定
      </el-button>
    </span>

  </el-dialog>
  <!-- 注意：@getMessage="showMessage" 是子画面回传值的方法 -->
  <supplier-select-dialog v-if="supplierSelectDialogVisible" ref="supplierSelectDialog" @getMessage="showMessage"></supplier-select-dialog>
</div>
</template>

<script>
  import { getNotice, addNotice, updateNotice } from '@/controller/supplier';
  import { DIALOG_CLOSED_TYPE } from '@/utils/const';
  import SupplierSelectDialog from "./supplier-select-dialog";
  import FileUpDown from "@/views/common/file-up-down";
  export default {
    components: {
        SupplierSelectDialog,
        FileUpDown, //上传附件
    },
    data () {
      return {
        visible: false,
        supplierSelectDialogVisible: false,
        sendListSize: 0,
        FILE_BIZ_TYPE:18,
        dataForm: {
          id: 0,
          noticeTitle: '',
          noticeType: '0',
          noticeStatus: '0',
          noticeContent: '',
          sendType: '',
          sendStatus: '',
          sendList: '',
        },
        dataRule: {
          noticeType: [
            { required: true, message: "类型不能为空", trigger: "change" }
          ],
          noticeStatus: [
            { required: true, message: "状态不能为空", trigger: "change" }
          ],
          noticeTitle: [
            { required: true, message: "标题不能为空", trigger: "blur" }
          ],
          noticeContent: [
            { required: true, message: "内容不能为空", trigger: "blur" }
          ],
          sendType: [
            { required: true, message: "通知类型不能为空", trigger: "blur" }
          ],
        },
        isNew: false,
      }
    },
    mounted () {
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
        this.$refs.FileUpDown.init('edit');
        this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            getNotice(
                    {},this.dataForm.id
            ).then(data => {
                if (data && data.code === '00') {
                    this.dataForm.noticeTitle = data.body.noticeTitle
                    this.dataForm.noticeType = data.body.noticeType
                    this.dataForm.noticeStatus = data.body.noticeStatus
                    this.dataForm.noticeContent = data.body.noticeContent
                    this.dataForm.sendType = data.body.sendType
                    this.dataForm.sendList = data.body.sendList
                    if(data.body.sendList != null && data.body.sendList.length > 0)
                        this.sendListSize = this.dataForm.sendList.split(',').length;
                }
            })
            this.isNew = false
          } else {
            this.sendListSize = 0
            this.isNew = true
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            let params = {
              'id': this.dataForm.id || undefined,
              'noticeTitle': this.dataForm.noticeTitle,
              'noticeType': this.dataForm.noticeType,
              'noticeStatus': this.dataForm.noticeStatus,
              'noticeContent': this.dataForm.noticeContent,
              'sendType': this.dataForm.sendType,
              'sendList': this.dataForm.sendType == 8 ? 0 : this.dataForm.sendList,
            }
            if(this.dataForm.id){
              updateNotice(
                      params
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                    }
                  })
                } else {
                  this.$message.error(data.msg)
                }

              }).catch(error => {
                console.log(error)
              })
            } else {
              addNotice(
                      params
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      this.dataForm.id = data.body.id
                      this.isNew = false
                      this.$emit('refreshDataList')
                    }
                  })
                } else {
                  this.$message.error(data.msg)
                }

              }).catch(error => {
                console.log(error)
              })
            }
          }
        })
      },
      // 选择供应商
      selectSupplier() {
        console.log(JSON.stringify("selectSupplier开始" + this.dataForm.sendList));
        this.supplierSelectDialogVisible = true;
        this.$nextTick(() => {
            this.$refs.supplierSelectDialog.open(this.dataForm.sendList, this.isNew);
            this.$refs.supplierSelectDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                  console.log("------DIALOG_CLOSED_TYPE.CONFIRM")
                }
            };
        });
      },
      // 父页面预留：接收子页面的返回值
      showMessage(sendList, flag) {
        console.log("父页面预留：接收子页面的返回值sendList=" + sendList);
        this.dataForm.sendList = sendList;
        this.sendListSize = sendList.split(',').length;
        this.isNew = flag;
      }
    }
  }
</script>
